import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicSslCertificateExtractCSRDetailsParamsRaw,
	type LWApiPublicSslCertificateExtractCSRDetailsResultRaw,
} from '@liquidweb-dev/club-sauce/public/ssl/certificate/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { getErrorStringHelper } from 'utility/redux/selectorHelperFunctions/apiModules';

export const SSL_CERTIFICATE_EXTRACT_CSR_DETAILS_QUERY_KEY =
	'/ssl/certificate/extractCSRDetails';

const useExtractCSRDetails = (
	params: LWApiPublicSslCertificateExtractCSRDetailsParamsRaw,
	options?: UseQueryOptions<
		LWApiPublicSslCertificateExtractCSRDetailsResultRaw,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [SSL_CERTIFICATE_EXTRACT_CSR_DETAILS_QUERY_KEY, params],
		queryFn: () => api.ssl.certificate.apiRaw.extractCSRDetails(params),
		...options,
	});

export const getCsrErrorStringHelper = (error: ApiErrorI) => {
	if (error?.statusCode === 400) {
		return 'CSR did not pass validation.';
	}

	return getErrorStringHelper(error);
};

export default useExtractCSRDetails;
